// Single source of truth for activityGroupId precedence.
// Order:
// 1. requested (explicitly set when opening from feed / overlay)
// 2. route param derived id (navigation / deep link)
// 3. null (none available)
// Rationale: Feed opens must be able to override a stale route param that still reflects a
// previously viewed group. A separate effect keeps requested in sync when actual navigation
// occurs so this precedence does not cause drift.
export function getEffectiveActivityGroupId({ requested, route }) {
  // Prefer a requested id (set by feed/overlay) unless we have only a route id.
  // Requested id is kept in sync with route id when navigation occurs to avoid staleness.
  return requested || route || null
}

export default getEffectiveActivityGroupId
